import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";
import { Signal } from "signals";


export default abstract class Popup
{
    // #region Attributes //

    // protected:

    protected _root: PIXI.Container = null;
    protected _disabledBg: PIXI.Graphics = null;
    
    // Signals.
    protected _onClosed: Signal = null;

    // #endregion //


    // #region Properties //

    // Signals.
    public get onClosed(): Signal { return this._onClosed; }

    // #endregion //


    // #region Methods //

    // public:

    // virtual.
    public onEnter( params: any = null ): void
    {
        this._onClosed = new Signal();

        this._root = new PIXI.Container();
        ServiceLocator.app.root.addChild( this._root );

        this._disabledBg = new PIXI.Graphics();
        const kBgAlpha: number = params && params.bgAlpha ? params.bgAlpha : 0.75;
        const kBgColor: number = params && params.bgColor ? params.bgColor : 0x000000;
        this._disabledBg.beginFill( kBgColor, kBgAlpha );
        const kSaveAreaMarginX: number = ( ServiceLocator.app.safeAreaWidth - ServiceLocator.app.width ) * 0.5;
        const kSaveAreaMarginY: number = ( ServiceLocator.app.safeAreaHeight - ServiceLocator.app.height ) * 0.5;
        this._disabledBg.drawRect( -kSaveAreaMarginX, -kSaveAreaMarginY, ServiceLocator.app.safeAreaWidth, ServiceLocator.app.safeAreaHeight );
        this._disabledBg.endFill();
        this._disabledBg.interactive = true;
        this._root.addChild( this._disabledBg );
    }

    // virtual.
    public onLeave(): void
    {        
        ServiceLocator.app.root.removeChild( this._root );
        this._root.destroy( { children: true } );
        this._root = null;

        this._disabledBg = null;

        this._onClosed.dispose();
        this._onClosed = null;
    }

    // virtual.
    public onUpdate( dt: number ) {}

    // protected:

    protected createTitle( title: string ): PIXI.Text
    {
        let titleText: PIXI.Text = new PIXI.Text( title, { fontSize: 92, fill: "white", stroke: "black", strokeThickness: 10, fontStyle: "italic" } );
        titleText.anchor.set( 0.5, 0 );
        titleText.position.set( ServiceLocator.app.width * 0.5, 20 );

        return titleText;
    }

    // #endregion //
}